module.exports = __webpack_public_path__ + "static/media/csm-minus.cdd9da86.svg";